import React, { Component } from 'react'
import { ContactUs } from "../components";

export class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bc : false,
        };
    }

    componentDidMount() {
        this.setBreadcrumb()
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.update===true){
            
        }
        
        this.setBreadcrumb()
    }

    setBreadcrumb(){
        const { main } = this.props
        const { bc } = this.state
        const { setBreadcrumb } = this.props

        if(bc===false){
            var title = (main.language)? main.language.MENU_CONTACT : "-"

            setBreadcrumb(title, [{name:title, link:"/contact"}])
            this.setState({ bc:true })
        }
    }

    render() {
        return (
            <main>
                <div role="main" className="main">
                    <ContactUs {...this.props} />
                </div>
            </main>
        )
    }
}

export default Contact
